module.exports = __webpack_public_path__ + "img/T1D_rc-14.f590485c.png";